
import './Spotify.scss';

const Spotify = () => {
  return (
    <div className="Spotify">
      <iframe
        src={`https://open.spotify.com/embed/artist/5285RdIACSO1Mv4yqEhD8H?utm_source=generator`}
        width="100%"
        height="380" 
        frameBorder="0" 
        allowfullscreen="" 
        allow="autoplay;clipboard-write;encrypted-media;fullscreen;picture-in-picture"
        loading="lazy"
      ></iframe>
    </div>
  );
};

export default Spotify;
